<mat-form-field>
  <div class="select">
    <mat-select
      #singleSelect
      [formControl]="selectCtrl"
      [placeholder]="placeholder"
      [compareWith]="compareFunction"
      [errorStateMatcher]="errorLabel !== undefined ? alwaysError : undefined"
      (closed)="propagateTouch()"
      [attr.data-testid]="testId"
    >
      <ng-container *ngIf="filteredOptions$ | async as filteredOptions">
        <mat-option>
          <ngx-mat-select-search
            [formControl]="filterCtrl"
            [noEntriesFoundLabel]="filterNoEntriesFoundLabel"
            [placeholderLabel]="filterPlaceholderLabel"
          >
            <svg-icon ngxMatSelectSearchClear key="cancel"></svg-icon>
          </ngx-mat-select-search>
        </mat-option>
        <ng-container *ngIf="filteredOptions.length">
          <mat-option *ngFor="let option of options" [value]="option" [class.d-none]="!filteredOptions.includes(option)">
            {{ option.title }}
          </mat-option>
        </ng-container>
      </ng-container>
    </mat-select>
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-error *ngIf="errorLabel !== undefined">{{ errorLabel }}</mat-error>
    <mat-hint *ngIf="hintLabel">{{ hintLabel }}</mat-hint>
  </div>
</mat-form-field>
